module.exports = __webpack_public_path__ + "img/icon3.1b2abe9a.png";